module.exports = {"component":"menu-dropdown","status":"prod","display-name":"Dropdown Menus","last-accessibility-review":{"date-iso-8601":"2018/01/18","commit-sha":"ad6b6c6523ee21cada11be5f7ea4d99abc530726"},"SLDS-component-path":"/components/menus#flavor-dropdown","dependencies":[{"component":"button-trigger"}],"url-slug":"menu-dropdowns"}


//////////////////
// WEBPACK FOOTER
// ./components/menu-dropdown/docs.json
// module id = 218
// module chunks = 0